import { render, staticRenderFns } from "./tecnicoCardSideBar.vue?vue&type=template&id=96bb650e"
import script from "./tecnicoCardSideBar.vue?vue&type=script&lang=js"
export * from "./tecnicoCardSideBar.vue?vue&type=script&lang=js"
import style0 from "./tecnicoCardSideBar.vue?vue&type=style&index=0&id=96bb650e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports